export default function ContractEA({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
  return (
    <div className="container mb100 mt100">
      <div className="beckertitlename mb100 mt100">Becker 美稅方案</div>

      <div className="card w-75 p-5 m-auto">
        <h5 className="card-title text-black text-center">
          捷進顧問有限公司「美國稅務入門全攻略」課程購買同意事項與條款
        </h5>

        <div className="br mb-5 mt-3"></div>

        <div className="card-body">
          <div className="card-text m-auto">
            <ol>
              <li>
                <div className="font-weight-bold">本服務內容</div>
                <p>
                  捷進顧問有限公司（下稱本公司）授權您於捷進中文雲端平台，使用乙方透過網際網路連線進行之教學、
                  討論或其他相關服務（以下簡稱「本服務」）。雙方關於本服務之權利義務，依本條款訂定之。
                </p>
              </li>

              <li>
                <div className="font-weight-bold">課程使用期限</div>
                <ul>
                  <li>
                    消費者於購買時須填寫一個「購買日起半年內」的啟動日，無論哪種方案（無論多長效期），方案的效期均自消費者指定之啟動日起算。
                  </li>
                  <li>
                    除「職涯無限方案」外所有方案，自指定啟動日起一年內，可不限次數隨選觀看。
                  </li>
                  <li>
                    「職涯無限方案」自指定啟動日起 24 個月內，可不限次數隨選觀看，滿 24 個月後得無償於課程上架期間內，不限次數隨選觀看。
                    於無償觀看期間，如本公司因營運終止、捷進中文雲端平台停止服務、講師未續約或有其他無法提供該課程之情形，導致無法繼續提供服務時，
                    公司得停止提供相關服務，且不負相關賠償或補償責任。
                  </li>
                </ul>
              </li>

              <li>
                <div className="font-weight-bold">智慧財產權</div>
                <ul>
                  <li>
                    本課程所有教材內容（包含但不限於線上影片、講義簡報、課程資料等）之智慧財產權皆屬捷進顧問有限公司所有，
                    僅提供已付費之客戶個人學習使用。
                  </li>
                  <li>
                    未經本公司書面授權，禁止以任何形式（包含但不限於錄製、翻印、轉載、截圖、翻拍、轉售、上傳網路分享等）
                    進行複製、散布、交易，或將其使用權讓與他人使用或與他人共用。如發現有上述侵權行為，本公司將依法追究相關民刑事責任。
                  </li>
                  <li>購買者不因付費購買而取得或享有該方案之內容所有權或智慧財產權。</li>
                </ul>
              </li>

              <li>
                <div className="font-weight-bold">課程內容更新說明</div>
                <p>本系列「美稅課程」係根據課程錄製當時最新法規製作，影片內容除本公司另行公告說明外，不提供後續更新服務。</p>
              </li>

              <li>
                <div className="font-weight-bold">課程觀看方式</div>
                <p>
                  課程提供於「捷進中文雲端平台」供客戶登入個人帳號觀看，禁止將個人帳號分享或出借他人，如發現違反上述規定，
                  本公司有權立即停止該帳號之使用權限，並保留法律追訴權。
                </p>
              </li>

              <li>
                <div className="font-weight-bold">使用授權費</div>
                <ul>
                  <li>本服務授權使用費之金額為該課程網頁上所標示價格，除雙方另有約定外，應一次繳納。</li>
                  <li>
                    本公司得以優惠價格提供您自由決定是否加價購買商品、教學課程或服務。契約終止或解除時，您依優惠方式加價購買之商品，
                    應就合約未到期日數或課程未使用次數比例返還優惠補貼款予本平台，優惠價格、優惠補貼款計算應另行約定。
                  </li>
                </ul>
              </li>

              <li>
                <div className="font-weight-bold">退費政策</div>
                <ul>
                  <li>
                    本商品屬於行政院公告之「通訊交易解除權合理例外情事適用準則」第 2 條可排除消費者保護法第 19 條七日解除權之合理例外情事者，
                    尚未領取商品（包括購買或因活動所獲贈之教科書）、且未開始參加課程、且未登入任何產品內含學習帳號者，得於購買後七日猶豫期內得要求退費。
                  </li>
                  <li>契約生效後逾 7 日，或教材一經領取，或線上課程平台帳號登入後，恕不退費亦不得要求暫停效期。</li>
                  <li>
                    若因可歸責本公司之事由，致消費者終止契約，且依法本公司應依比例返還消費者授權費時，返還比例如下：
                    <div className="note mt-2">
                      <div>[職涯無限方案]：授權使用費 ×（尚未使用日數 ÷ 24 個月總日數），無償贈與期間不得列入計算。</div>
                      <div>[其他方案]：授權使用費 ×（尚未使用日數 ÷ 授權期間總日數）。</div>
                    </div>
                  </li>
                </ul>
              </li>

              <li>
                <div className="font-weight-bold">帳號安全</div>
                <p>
                  學員領取帳號後，應妥善保管其登入密碼，確保不為他人得知；利用學員帳號密碼登入學習帳號，將推定為學員本人之行為。
                  因非可歸責於捷進顧問之事由導致登入密碼外洩時，學員應儘速通知，捷進顧問除提供必要協助外，不負任何法律上責任。
                </p>
                <p>本公司保留針對疑似帳號異常使用行為（如多地 IP 登入）之審核與凍結權利，以防止共享帳號。</p>
              </li>

              <li>
                <div className="font-weight-bold">授權使用原則</div>
                <p>您若有下列情形之一者，應自負一切法律責任，本公司並得通知終止本契約，您不得拒絕：</p>
                <ul>
                  <li>蓄意散布干擾企業經營者網站系統正常運作之電腦程式。</li>
                  <li>在本公司網站系統上散布恐嚇、毀謗、侵害他人隱私、色情或其他違反強制或禁止規定、公序良俗之文字、圖片或影像。</li>
                </ul>
                <p>
                  您利用本服務從事其他不法或違反本契約約定事項之行為，其情節重大，且經本公司通知限期改正而屆期未改正者，
                  本公司得通知終止本契約，您不得拒絕。
                </p>
                <p>企業經營者依前二項之約定終止本契約者，您若符合第七條退費條件，本公司得於返還金額中扣除百分之二十之違約金。</p>
              </li>

              <li>
                <div className="font-weight-bold">消費者之義務</div>
                <ul>
                  <li>您對於使用本服務所產生之授權使用費，有按時給付之義務，並對本契約終止前已產生之授權使用費，有繳納之義務。</li>
                  <li>您所註冊之個人資料有錯誤或已變更者，應儘速通知本公司請求更正。如因您怠於通知而致其權益受損者，應自行負責。</li>
                </ul>
              </li>

              <li>
                <div className="font-weight-bold">購買資格</div>
                <p>購買方案者保證為完全行為能力人或已得法定代理人同意之限制行為能力人。</p>
              </li>

              <li>
                <div className="font-weight-bold">軟硬體設備基本規格及要求</div>
                <div>
                  <div className="font-weight-bold mt-2">系統需求：</div>
                  <ul>
                    <li>Windows PC/NB：Windows 7 以上</li>
                    <li>Apple PC/NB：macOS 10 以上</li>
                    <li>Apple 行動裝置：iOS 13.0 以上（行動裝置限定使用 APP 版觀看課程）</li>
                    <li>Android 行動裝置：Android 8.0 以上（行動裝置限定使用 APP 版觀看課程）</li>
                  </ul>
                  <div className="font-weight-bold mt-2">連線需求：</div>
                  <ul>
                    <li>寬頻網路下載速度 20Mbps 以上</li>
                    <li>不建議無線、社區型、有線電視台網路、公共免費網路，可能造成無法正常驗證登入或個人帳號密碼資料外洩。</li>
                    <li>其餘未列示之軟硬體或系統，恕不保證其觀看學習品質。</li>
                  </ul>
                  <p>
                    您連結「捷進中文雲端平台」機房設備之接取網路，應自行向合法經營之電信事業申請租用，
                    您租用該接取網路所生之權利義務，依您與該電信事業間契約約定之。
                  </p>
                </div>
              </li>

              <li>
                <div className="font-weight-bold">第三方內容與網站規範</div>
                <p>
                  捷進顧問公司提供的中文雲端看課平台可能含有來自協力廠商及第三方之內容或至其他第三方網站之鍵結，
                  平台用戶使用時應瞭解本公司不負責檢查或評估該第三方內容，亦不負任何責任。
                </p>
              </li>

              <li>
                <div className="font-weight-bold">服務品質及暫停服務</div>
                <ul>
                  <li>本公司應提供具有可合理期待安全性之服務。</li>
                  <li>教學內容與教材若有錯誤，本公司應於知悉之日起算三個工作日內（國定假日、例假日、防災假除外）完成更正或修復，並於網站公告錯誤內容。</li>
                  <li>本公司對於本服務相關軟硬體設備，進行營運上必要之搬遷、更換、升級、保養或維修時，得暫停本服務之全部或一部。</li>
                  <li>
                    本公司因前項事由而暫停本服務之全部或一部，應於暫停本服務七日前，於本服務網站首頁上及本服務進行中公告，
                    並以電子郵件或書面通知消費者。但因臨時性、急迫性或不可歸責於本公司之事由者，不在此限。
                  </li>
                </ul>
              </li>

              <li>
                <div className="font-weight-bold">契約變更</div>
                <ul>
                  <li>本公司修改本條款時，應於三十日前於網站系統公告之，同時以電子郵件或書面通知消費者。</li>
                  <li>消費者未為反對之表示且繼續使用本服務者，企業經營者依契約變更後之內容繼續提供本服務。</li>
                  <li>消費者不同意第一項之變更，得於公告後三十日內向企業經營者主張終止契約。</li>
                </ul>
              </li>

              <li>
                <div className="font-weight-bold">隱私權聲明</div>
                <p>
                  本公司依個資法規定蒐集您註冊時填寫的個人資料（包括：姓名、電子郵件信箱、付款資訊），
                  使用範圍包含訂購確認、帳號註冊、學員管理及行銷服務。本公司將於服務存續期間或依法律規定之保存期限內，
                  在中華民國境內利用您提供之個資。未經您同意，本公司不會販售或提供給未經授權之第三方。
                </p>
                <p>
                  您得依法行使個資法相關權利，如欲行使權利請來信
                  <a href="mailto:service@beckertw.com" className="ml-1">service@beckertw.com</a>。
                  您若未提供您的資料，可能影響您完成購客及使用本服務之權益。
                </p>
              </li>

              <li>
                <div className="font-weight-bold">管轄法院</div>
                <p>
                  因本協議所生之一切爭議，雙方當事人同意以臺灣臺北法院為第一審管轄法院，
                  但不得排除消費者保護法第四十七條或民事訴訟法第四百三十六條之九有關小額訴訟管轄法院之適用。
                </p>
              </li>

              <li>
                <div className="font-weight-bold">公司資訊</div>
                
                  <div><strong>捷進顧問有限公司</strong></div>
                  <div>電話：<a href="tel:+886227000053">02-2700-0053</a></div>
                  <div>客戶服務電子郵件：<a href="mailto:service@beckertw.com">service@beckertw.com</a></div>
                  <div>營業所地址：台北市大安區信義路四段 6 號 16 樓之 12</div>
                  <div>統一編號：80523352</div>
                
              </li>
            </ol>
          </div>

          <div className="text-center mt-4">
            <label>
              <input
                className="m-2"
                type="checkbox"
                value="read"
                checked={isChecked}
                onChange={handleCheckboxChange}
                required
              />
              <span>我已詳閱並且了解</span>
            </label>
            <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>
              下一步
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
